import { ArchivoxProvider } from "@ioip/archivox/lib";
import { IArchivoxApi } from '@ioip/archivox/lib/apis';
import { Grid, Row, confirmationSlice, languageSlice, layoutSlice, pluginEditorSlice } from '@ioip/core/lib';
import { ProcesoxProvider } from '@ioip/procesox/lib';
import { ITramitexApi, TramitexProvider, } from '@ioip/tramitex/lib';
import React from 'react';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import './App.css';
import { Sede } from './classes/shared';
import { CheckAccountErrorComponent } from './components/check-account-error/check-account-error.component';
import { CheckAnonymousRequestComponent } from './components/check-anonymous-request/check-anonymous-request.component';
import CrearSolicitudComponent from './components/crear-solicitud/crear-solicitud.component';
import { CreatePqrComponentMode } from './components/crear-solicitud/create-pqr-mode.enum';
import { CreateContactNewUserComponent } from './components/create-contact-component/create-contact-new-user.component';
import { CreateContactComponent } from './components/create-contact-component/create-contact.component';
import { DescargaComponent } from './components/descarga-component/descarga.component';
import { EditContactComponent } from './components/edit-contact/edit-contact.component';
import { MyPendingWorksComponentMode } from './components/entidades-adscritas/my-pending-works/my-pending-works-mode.enum';
import { MyPendingWorksComponent } from './components/entidades-adscritas/my-pending-works/my-pending-works.component';
import { HomeComponent } from './components/home-component/home.component';
import { MyRequestsComponentMode } from './components/my-requests/my-requests-mode.enum';
import { MyRequestsComponent } from './components/my-requests/my-requests.component';
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';
import { SatisfactionSurveyComponent } from './components/satisfaction-survey/satisfaction-survey.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { VerifiDocumentComponent } from './components/verify-document/verify-document.component';
import { $_, initSdk, showError, successToast } from './ioip/sdk/base';
import { PqrWebService } from './services/services';
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";

interface IAppState {
  isLoading: boolean;
}

export const store = configureStore({
  reducer: {

    // @ioip\core
    [ confirmationSlice.name ]: confirmationSlice.reducer,
    [ layoutSlice.name ]: layoutSlice.reducer,
    [ pluginEditorSlice.name ]: pluginEditorSlice.reducer,
    [ languageSlice.name ]: languageSlice.reducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat([

  ]),
  devTools: {
    name: 'Archivox/Tramitex/Processox',
    trace: process.env.NODE_ENV !== 'production',
    traceLimit: 2500
  }
});

export class App extends React.Component<any, IAppState> {

  constructor(props: IAppState) {
    super(props);
    initSdk();
    this.state = {
      isLoading: true
    };
  }

  async componentDidMount(): Promise<void> {
    const service = new PqrWebService();
    Sede.Shared.Context = await service.getContextAsync();
    this.setState({ isLoading: false });
  }

  render(): JSX.Element {

    const hostFunctions = (): any => {
      return {
        createChunkDocumentAsync: () => null,
        appendChunkContentAsync: () => null,
        showError: (text: string) => showError(text),
        showMessage: (text: string, title: string, callback?: () => void) => showError(text),
        successToast: (text: string) => successToast(text),
        downloadFieldDataSourceAsync: (projectId: string, formVersionId: string, fieldId: string) => $_.svc.ProcesoX.ProjectSvc.downloadFieldDataSourceAsync(projectId, formVersionId, fieldId, {}),
        downloadParametricEntityItems: (projectId: string, entityId: string) => $_.svc.ProcesoX.ProjectSvc.downloadParametricEntityItems(projectId, entityId),
        searchInputFilesAsync: async () => Promise.resolve([])
      };
    };

    const archivoxApis: IArchivoxApi = {
      getCitiesAsync: async () => {
        return [];
      },
      getCountriesAsync: async () => {
        return [];
      },
      getDepartmentsAsync: async () => {
        return [];
      },
      getProfilesAsync: async () => {
        return [];
      },
      getRoles: async () => {
        return [];
      },
      getSectionsAsync: async () => {
        return [];
      },
      getSeriesAsync: async () => {
        return [];
      },
      getSubseriesAsync: async () => {
        return [];
      },
      getTrdVersionsAsync: async () => {
        return [];
      },
      getUsersAsync: async () => {
        return [];
      }
    }

    const tramitexApis: ITramitexApi = {
      getAgeRangesAsync: async () => {
        return [];
      },
      getCompanyTypesAsync: async () => {
        return [];
      },
      getContactTypesAsync: async () => {
        return [];
      },
      getDisabilitiesAsync: async () => {
        return [];
      },
      getEducationLevelsAsync: async () => {
        return [];
      },
      getEthnicGroupsAsync: async () => {
        return [];
      },
      getGendersAsync: async () => {
        return [];
      },
      getIdentificationTypesAsync: async () => {
        return [];
      },
      getOrientationSectorsAsync: async () => {
        return [];
      },
      getPreferentialTreatmentsAsync: async () => {
        return [];
      },
      getProceduresAsync: async () => {
        return [];
      },
      getProfessionsAsync: async () => {
        return [];
      }
    }

    return this.state.isLoading
      ? <div>Cargando...</div>
      : <Provider store={store}>
        <div style={{ padding: '10px' }}>
          <div id='div-loader'>
          </div>
          <Grid>
            <Row>
              <div className="ms-Grid-col ms-md2 ms-lg2 ms-u-hiddenSm"></div>
              <div className="ms-Grid-col ms-u-sm8">
                <ArchivoxProvider apis={archivoxApis}>
                  <TramitexProvider apis={tramitexApis} >
                    <ProcesoxProvider baseUrl={Sede.Shared.ProcesoxUrl}>
                      <HashRouter>
                        <Switch>
                          <Redirect exact from="/" to="/home" />
                          <Route exact path="/home" component={HomeComponent} />
                          <Route exact path="/descarga" component={DescargaComponent} />
                          <Route exact path="/create-contact" component={CreateContactComponent} />
                          <Route exact path="/create-contact/new-user" component={CreateContactNewUserComponent} />
                          <Route exact path="/edit-contact" component={EditContactComponent} />
                          <Route exact path="/products" component={CrearSolicitudComponent} />
                          <Route exact path="/sign-in/create-pqr" component={() => <SignInComponent ulrForm={'#/create-pqr'} />} />
                          <Route exact path="/sign-in/my/requests" component={() => <SignInComponent ulrForm={'#/my/requests'} />} />
                          <Route exact path="/recover-password" component={RecoverPasswordComponent} />
                          <Route exact path="/create-pqr" render={() => <CrearSolicitudComponent mode={CreatePqrComponentMode.Create} />} />
                          <Route exact path="/create-pqr/anonymous/:sessionId?" render={() => <CrearSolicitudComponent mode={CreatePqrComponentMode.CreateAnonymous} />} />
                          <Route exact path="/my/requests" render={p => <MyRequestsComponent {...p} mode={MyRequestsComponentMode.MyRequests} />} />
                          <Route exact path="/my/requests/anonymous" render={p => <MyRequestsComponent {...p} mode={MyRequestsComponentMode.MyRequestsAnonymous} />} />
                          <Route exact path="/check-account-error/:message?" component={CheckAccountErrorComponent} />
                          {/* <Route exact path="/recover-question" component={RecoverQuestionComponent} /> */}
                          <Route exact path="/check-anonymous-request" component={CheckAnonymousRequestComponent} />
                          {/* <Route exact path="/recover-secret-answer/:idcontacto" component={RecoverSecretAnswerComponent} /> */}
                          <Route exact path="/satisfaction-survey/:idRadicadoSalida64" component={SatisfactionSurveyComponent} />
                          <Route exact path="/sign-in/answer-rs" component={() => <SignInComponent ulrForm={'#/answer-rs'} />} />
                          <Route exact path="/answer-rs" render={p => <MyPendingWorksComponent {...p} mode={MyPendingWorksComponentMode.MyPendingWorksComponentMode} />} />
                          <Route exact path="/verify-document/:documentId?" component={VerifiDocumentComponent} />
                        </Switch>
                      </HashRouter>
                    </ProcesoxProvider>
                  </TramitexProvider>
                </ArchivoxProvider>
                <div>
                  <div className='ms-Grid-col ms-u-sm12' style={{ textAlign: 'center', marginTop: '10px' }}>
                    <p className="mt-5 mb-3 text-muted" style={{ fontSize: '10px' }}>Tramitex WebClient<br />COPYRIGHT © {new Date().getFullYear()} IOIP SAS - 2.0.12.1</p>
                  </div>
                </div>
              </div>
              <div className="ms-Grid-col ms-md2 ms-lg2 ms-u-hiddenSm"></div>
            </Row>
          </Grid>
        </div>
      </Provider>;
  }

}

export default App;
